import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const homeKey = 'home'

const routes = [
  {
    path: '/', // app.vue页面的方法（loginBindHandle）有对path === /的判断
    component: () => import(/* webpackChunkName: "Home" */ '@/views/Home/index.vue')
  },
  {
    path: '/buyDialog',
    component: () => import(/* webpackChunkName: "BuyDialog" */ '@/views/BuyDialog/index.vue'),
  },
  {
    path: '/matDetailDialog',
    component: () => import(/* webpackChunkName: "MatDetailDialogMini" */ '@/views/MatDetailDialog/index.vue')
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "Login" */ '@/views/Login/wanmeiLogin.vue')
  },
  {
    path: '/qqLogin', // 与登录跳转有关，注意
    component: () => import(/* webpackChunkName: "qqLogin" */ '@/views/Login/qqLogin.vue')
  },
  {
    path: '/keniuPublicLogin',
    component: () => import(/* webpackChunkName: "KeniuPublicLogin" */ '@/views/Login/keniuPublicLogin.vue')
  },
  {
    path: '/loginRetain',
    component: () => import(/* webpackChunkName: "loginRetain" */ '@/views/LoginRetain/index.vue')
  },
  {
    path: '/error/:id',
    component: () => import(/* webpackChunkName: "error" */ '@/views/Error.vue'),
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
